import axios from 'axios';

/**
 * Request to check salary.
 *
 * @param {Object} params
 * @returns {Boolean}
 */
const getCallback = async (params) => axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
  callback: params.callback || '@Callbacks/getSalaryCheckerData',
  currentRoute: params.currentRoute,
  currentLanguage: params.locale || 'en',
  data: params.data,
});

export default getCallback;
